import { render, staticRenderFns } from "./VehicleBulbFilters.vue?vue&type=template&id=4e2fac94&scoped=true"
import script from "./VehicleBulbFilters.vue?vue&type=script&lang=js"
export * from "./VehicleBulbFilters.vue?vue&type=script&lang=js"
import style0 from "./VehicleBulbFilters.vue?vue&type=style&index=0&id=4e2fac94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2fac94",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductTechnicalFilters: require('/app/components/ProductTechnicalFilters.vue').default})
